import React, { createContext, useContext, useReducer } from "react";

// Create a context
const ShippingMethodContext = createContext();

// Define action types
const SET_STATE = "SET_STATE";

// Reducer function
const appReducer = (state, action) => {
  switch (action.type) {
    case SET_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    default:
      return state;
  }
};

// Create a provider component
export const ShippingMethodContextProvider = ({ children }) => {
  const [shippingState, dispatch] = useReducer(appReducer, {
    distanceBasedAreas: [],
    selectedStore: {},
  });

  const updateShippingState = (key, value) => {
    dispatch({
      type: SET_STATE,
      payload: { key, value },
    });
  };

  return (
    <ShippingMethodContext.Provider
      value={{ shippingState, updateShippingState }}
    >
      {children}
    </ShippingMethodContext.Provider>
  );
};

// Create a custom hook for using the context
export const useShippingContext = () => {
  const context = useContext(ShippingMethodContext);
  if (!context) {
    throw new Error("useAppState must be used within an AppStateProvider");
  }
  return context;
};
